import React, { useState } from 'react';
import axios from 'axios';
import { getApiBase } from '../utils/api';

const MicrosoftSSOButton = ({ onError }) => {
  const [loading, setLoading] = useState(false);

  const handleMicrosoftSignIn = async () => {
    try {
      setLoading(true);
      // Get Microsoft auth URL from backend
      const apiBase = getApiBase();
      const response = await axios.get(`${apiBase}/auth/microsoft/url`, {
        withCredentials: true
      });
      const authUrl = response.data.auth_url;

      // Redirect to Microsoft OAuth
      window.location.href = authUrl;
    } catch (error) {
      console.error('Microsoft sign-in error:', error.response?.status, error.response?.data?.detail || error.message);

      let errorMessage = 'Failed to initiate Microsoft sign-in. Please try again.';

      // Provide more specific error messages based on the error type
      if (error.response) {
        // Server responded with an error
        if (error.response.status === 503) {
          errorMessage = error.response.data?.detail || 'Microsoft Sign-In is not configured. Please contact your administrator.';
        } else if (error.response.status === 500) {
          errorMessage = 'Server error while initiating Microsoft sign-in. Please try again later.';
        } else {
          errorMessage = error.response.data?.detail || errorMessage;
        }
      } else if (error.request) {
        // Request was made but no response received (network error, CORS, etc.)
        errorMessage = 'Unable to connect to the server. Please check your connection and try again.';
      }

      if (onError) {
        onError(errorMessage);
      }
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleMicrosoftSignIn}
      disabled={loading}
      className="group relative w-full flex justify-center items-center py-2 px-4 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
    >
      {loading ? (
        <>
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-700 mr-2"></div>
          Redirecting...
        </>
      ) : (
        <>
          <svg className="w-5 h-5 mr-2" viewBox="0 0 23 23">
            <path fill="#f3f3f3" d="M0 0h23v23H0z"/>
            <path fill="#f35325" d="M1 1h10v10H1z"/>
            <path fill="#81bc06" d="M12 1h10v10H12z"/>
            <path fill="#05a6f0" d="M1 12h10v10H1z"/>
            <path fill="#ffba08" d="M12 12h10v10H12z"/>
          </svg>
          Continue with Microsoft
        </>
      )}
    </button>
  );
};

export default MicrosoftSSOButton;
